// GET /amenities/v1/properties/{propertyId}/amenities
// GET /amenities/v1/properties/{propertyId}/rooms/{roomId}/amenities
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Response } from '@data/models';
import { apiCall } from '../axios';
export class AmenitiesService {
    static fetchAmenities(_a) {
        return __awaiter(this, arguments, void 0, function* ({ type, propertyId, roomId, }) {
            const res = yield apiCall(Response)('get', '/amenities', {
                property_id: propertyId,
                room_id: roomId,
                type,
            }).catch(() => {
                return null;
            });
            if (!res || res.error || !res.data) {
                return [];
            }
            const data = res.data;
            // Remove the "name" key from the API response forcing the use of i18n keys
            const amenities = (data.amenities || []).map((amenity) => (Object.assign(Object.assign({}, amenity), { name: '' })));
            const customAmenities = (data.customAmenities || []).map((amenity) => ({
                categoryCode: '',
                code: '',
                isTop: false,
                name: amenity,
            }));
            return [...amenities, ...customAmenities];
        });
    }
    static fetchPropertyAmenities(propertyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetchAmenities({ propertyId, type: 'property' });
        });
    }
    static fetchRoomAmenities(propertyId, roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetchAmenities({ propertyId, roomId, type: 'room' });
        });
    }
}
